import React, {type ReactNode} from 'react'

interface PopoverDrawerHeaderProps {
  children?: string
  onClose?: () => void
}

export default function PopoverDrawerHeader({
                                              children,
                                              onClose
                                            }: PopoverDrawerHeaderProps): ReactNode {
  return (
    <div
      className={'sticky top-0 left-0 rounded-t-lg py-3 border dark:border-storm-40 border-storm-90 flex flex-row font-bold text-[18px] text-storm-10 dark:text-storm-100 text-capitalize w-full justify-center bg-white dark:bg-storm-20'}>
      <div className={'max-w-lg w-full flex flex-row px-6 flex-1'}>
        <div className={'flex-1'}>
          {children}
        </div>
        <button type={'button'} className={'inline-flex items-center -my-1 transform hover:scale-125 duration-100'}
                onClick={onClose}>
          <svg className={'stroke-storm-40 dark:stroke-storm-90 w-7 h-7'} width="24" height="24" viewBox="0 0 24 24"
               fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="heroicons-outline/x-mark">
              <path id="Vector" d="M6 18L18 6M6 6L18 18" strokeWidth="1.5" strokeLinecap="round"
                    strokeLinejoin="round"/>
            </g>
          </svg>
        </button>
      </div>
    </div>
  )
}
